import React from 'react';
import Page from '../components/Page';
import Article from '../components/Article';
import { Typography, Link } from '@mui/material';
import { useTenant } from '../contexts/TenantContext';

const PrivacyPolicyLayout = () => {
  const { legal, displayConfig } = useTenant();

  return (
    <Page>
      {/* The text takes the tenant's colour: left to MUI's dark default, it cannot be read on a dark theme's card. */}
      <Article title="Adatkezelési Nyilatkozat" titleVariant="h5" alignItems="start" sx={{ color: displayConfig?.color }}>
        <Typography variant="h5" my={3}>
          1. Bevezetés
        </Typography>
        <Typography paragraph>
          Ez az adatvédelmi tájékoztató leírja, hogyan gyűjtjük, használjuk és védjük az Ön személyes adatait, amikor a weboldalt használja, 
          amelyen keresztül időpontot foglalhat a szolgáltatást nyújtó vállalkozó szolgáltatásaira.
        </Typography>

        <Typography variant="h5" my={3}>
          2. Az Adatkezelő Adatai
        </Typography>
        <Typography paragraph>
          Név: {legal?.name} <br />
          Székhely: {legal?.address} <br />
          E-mail: {legal?.email} <br />
          Telefonszám: {legal?.phoneNumber} <br />
          Nyílvántartási szám: {legal?.registrationNumber} <br />
          Adószám: {legal?.taxNumber} <br />
        </Typography>

        <Typography variant="h5" my={3}>
          3. Gyűjtött Adatok Típusa
        </Typography>
        <Typography paragraph>
          Az alábbi személyes adatokat gyűjtjük a felhasználók időpontfoglalásai és hitelesítése során: <br />
          • E-mail cím <br />
          • Név <br />
          • Telefonszám <br />
          • Foglalt időpont dátuma, kezdési és befejezési időpontja, időtartama <br />
          • A foglalt szolgáltatás jellege <br />
          • A foglaláshoz választott munkatárs, ha a vállalkozónál több munkatárs közül lehet választani <br />
          • A foglalás ára, és ha kedvezményes kupont használt, a kupon kódja <br />
          • Jelszó, ha email címmel és jelszóval regisztrál <br />
          • A marketing levelekhez adott hozzájárulás időpontja, ha hozzájárult <br />
          <br />
          A bejelentkezés Google-fiókkal (Google OAuth2) vagy email címmel és jelszóval történik. A jelszót kizárólag
          visszafejthetetlen, egyirányú titkosítással (bcrypt hash) tároljuk, így azt senki, mi sem ismerhetjük meg.
          Az email cím igazolásához és új jelszó beállításához egy 6 jegyű, 15 percig érvényes kódot küldünk e-mailben.
          A meg nem erősített regisztrációk adatait 24 óra elteltével töröljük.
          Ha a foglalást a vállalkozó rögzíti az Ön nevében, az Ön által megadott e-mail címre visszaigazolást
          küldünk a foglalásról, és értesítést, ha a foglalást törlik.
          A weboldal cookie-t használ az autentikációhoz szükséges hozzáférési token tárolására.
        </Typography>

        <Typography variant="h5" my={3}>
          4. Adatkezelés Célja
        </Typography>
        <Typography paragraph>
          • A szolgáltatás nyújtásához szükséges adatok kezelése <br />
          • A felhasználókkal való kommunikáció a foglalások megerősítése céljából <br />
          • Szolgáltatásaink fejlesztése és javítása a felhasználói visszajelzések alapján <br />
          • Marketing levelek (akciók, újdonságok) küldése e-mailben, kizárólag annak, aki ehhez kifejezetten hozzájárult
        </Typography>

        <Typography variant="h5" my={3}>
          5. Az Adatkezelés Jogi Alapja
        </Typography>
        <Typography paragraph>
          Az adatkezelés jogalapja a felhasználó hozzájárulása, amelyet a weboldal használatával ad meg, valamint az adatkezelés szükségessége az időpontfoglalási szolgáltatás nyújtása érdekében.
        </Typography>
        <Typography paragraph>
          Marketing levelet kizárólag az Ön kifejezett hozzájárulása alapján kaphat, amelyet a regisztrációkor egy
          jelölőnégyzet bepipálásával, vagy később a profiljában adhat meg. A hozzájárulását bármikor, ingyenesen és
          indoklás nélkül visszavonhatja a profiljában, vagy a marketing levélre válaszolva. A visszavonás nem érinti
          a korábban küldött levelek jogszerűségét.
        </Typography>

        <Typography variant="h5" my={3}>
          6. Adatok Megosztása és Nyilvánosságra Hozatala
        </Typography>
        <Typography paragraph>
          Az Ön személyes adatait harmadik féllel nem osztjuk meg. Az adatokat a szolgáltatást nyújtó személy láthatja, mivel az időpontfoglalások kezelése és adminisztrációja érdekében hozzáférése van a foglalások során megadott személyes adatokhoz (név, e-mail cím, telefonszám, a foglalt időpont dátuma, kezdési és befejezési időpontja, időtartama, a foglalt szolgáltatás jellege). Ezen adatokhoz kizárólag a szolgáltatást nyújtó vállalkozó és az alábbiak szerint a munkatársa fér hozzá a szolgáltatás nyújtása céljából, valamint az adatfeldolgozó karbantartás céljából.
        </Typography>
        <Typography paragraph>
          Ha a vállalkozónál több munkatárs nyújtja a szolgáltatást, a fenti adatokat az a munkatárs is láthatja, akihez
          a foglalás szól, a saját foglalásainak kezelése céljából. Más munkatárs foglalásait és azok adatait nem látja.
        </Typography>
        <Typography paragraph>
          A marketing leveleket a szolgáltatást nyújtó vállalkozó a saját e-mail fiókjából küldi. Ehhez a hozzájárulást
          adó felhasználók nevét és e-mail címét töltheti le a weboldalról.
        </Typography>

        <Typography variant="h5" my={3}>
          7. Adatmegőrzési Időszak
        </Typography>
        <Typography paragraph>
          Az Ön személyes adatait a weboldal működéséig, vagy a törlési kérelem beérkezéséig, de legfeljebb 5 évig őrizzük meg.
        </Typography>

        <Typography variant="h5" my={3}>
          8. Felhasználói Jogok
        </Typography>
        <Typography paragraph>
          Önnek jogában áll: <br />
          • Hozzáférést kérni az Önről tárolt adatokhoz. <br />
          • Az adatok helyesbítését kérni. <br />
          • Az adatok törlését kérni. <br />
          • Az adatkezelés korlátozását kérni. <br />
          • Tiltakozni az adatkezelés ellen. <br />
          <br />
          Ezen jogait gyakorolhatja a fenti elérhetőségeken keresztül. Ha Ön úgy véli, hogy az adatkezelés során jogsértés történt, joga van panaszt tenni a Nemzeti Adatvédelmi és Információszabadság Hatóságnál (NAIH). A NAIH elérhetőségei: <br />
          • Cím: 1055 Budapest, Szalay utca 10-14. <br />
          • Weboldal: <Link href="https://naih.hu" target="_blank" rel="noopener noreferrer">https://naih.hu</Link>
        </Typography>

        <Typography variant="h5" my={3}>
          9. Adatbiztonság
        </Typography>
        <Typography paragraph>
          Az Ön adatait biztonságos, titkosított kapcsolat (HTTPS) használatával védjük. Továbbá a Google OAuth2 hitelesítési szolgáltatása biztosítja a biztonságos belépést. Az adatokat kizárólag a szolgáltatást nyújtó vállalkozó és a foglalás szerinti munkatársa számára tesszük elérhetővé, akik szintén csak bejelentkezés után érik el őket.
        </Typography>

        <Typography variant="h5" my={3}>
          10. Az Adatvédelmi Tájékoztató Módosítása
        </Typography>
        <Typography paragraph>
          Fenntartjuk a jogot az adatvédelmi tájékoztató módosítására. A változásokat a weboldalon tesszük közzé, és a módosított tájékoztató a közzétételt követően azonnal hatályba lép. A felhasználóknak ajánlott rendszeresen ellenőrizniük az adatvédelmi tájékoztatót a legfrissebb információkért. A weboldal használatával a felhasználók elfogadják a módosításokat.
        </Typography>

        <Typography variant="h5" my={3}>
          11. Adatfeldolgozó
        </Typography>
        <Typography paragraph>
          A weboldal technikai üzemeltetését az adatkezelő megbízásából adatfeldolgozó végzi. Az adatfeldolgozó a felhasználók adatait kizárólag a weboldal technikai működtetése és karbantartása céljából kezeli, és nem fér hozzá az adatokhoz, kivéve a technikai karbantartás során. Az adatkezelés minden más vonatkozásában az adatkezelő felelős.
        </Typography>
        <Typography paragraph>
          Az adatfeldolgozó kilétéről és elérhetőségéről, valamint az adatkezeléssel kapcsolatos minden kérdésben
          az adatkezelő ad tájékoztatást, a 2. pontban megadott elérhetőségeken.
        </Typography>
      </Article>
    </Page>
  );
};

export default PrivacyPolicyLayout;
